// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { rtdbPlugin } from 'vuefire'
import App from './App'
import router from './router'
import store from './store'
import titleMixin from './util/title';
import * as filters from './util/filters';
import ElementUI from 'element-ui';
import en from "element-ui/lib/locale/lang/en";
import InfiniteLoading from 'vue-infinite-loading'
Vue.use(InfiniteLoading)
var VueCookie = require('vue-cookie');
Vue.use(ElementUI, { locale: en });
import _ from 'lodash'
Vue.prototype._ = _
import moment from 'moment'
Vue.prototype.moment = moment
// import { sync } from 'vuex-router-sync';
import ProgressBar from './components/ProgressBar.vue'
Vue.use(rtdbPlugin, { wait: true });
// global progress bar
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)
Vue.use(VueCookie)
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// Services
Vue.config.productionTip = false

// mixin for handling title
Vue.mixin(titleMixin)

Vue.use(VueCookie)

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.mixin({
  beforeRouteUpdate (to, from, next) {
    const { asyncData } = this.$options
    if (asyncData) {
      asyncData({
        store: this.$store,
        route: to
      }).then(next).catch(next)
    } else {
      next()
    }
  }
})

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
}

// wait until router has resolved all async before hooks
// and async components...
router.onReady(() => {
  // Add router hook for handling asyncData.
  // Doing it after initial route is resolved so that we don't double-fetch
  // the data that we already have. Using router.beforeResolve() so that all
  // async components are resolved.
  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to)
    const prevMatched = router.getMatchedComponents(from)
    let diffed = false
    const activated = matched.filter((c, i) => {
      return diffed || (diffed = (prevMatched[i] !== c))
    })
    const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _)
    if (!asyncDataHooks.length) {
      return next()
    }

    bar.start()
    Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
      .then(() => {
        bar.finish()
        next()
      })
      .catch(next)
  })

  // actually mount to DOM
  // app.$mount('#app')
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js